import classNames from 'classnames';
import React from 'react';

import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import TextArea from 'ui-library/bs/TextArea';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';

const CUSTOM_BARCODE = 'custom-barcode';
const AUTOGENERATE_BARCODE = 'autogenerate-barcode';

export interface BarcodeInputProps {
  customBarcode: string;
  error?: string;
  shouldAutogenerateBarcode: boolean;
  onUpdate: (update: {customBarcode?: string; shouldAutogenerateBarcode?: boolean}) => void;
}

class BarcodeInput extends React.Component<BarcodeInputProps> {
  private handleChangeShouldAutogenerateBarcode = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.props.onUpdate({
      shouldAutogenerateBarcode: e.target.value === AUTOGENERATE_BARCODE,
    });
  };

  private handleChangeCustomBarcode = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    this.props.onUpdate({
      customBarcode: e.target.value,
    });
  };

  render(): JSX.Element {
    return (
      <FormGroup>
        <Row bufferRowReset={true}>
          <Col md={12}>
            <FieldLabel isRequired={true} label="Barcode" labelStyle={FieldLabel.STYLES.LABEL} />
          </Col>
        </Row>
        <Row bufferRowReset={true}>
          <Col md={6}>
            <input
              checked={this.props.shouldAutogenerateBarcode}
              onChange={this.handleChangeShouldAutogenerateBarcode}
              type="radio"
              value={AUTOGENERATE_BARCODE}
            />
            <span className="u-tiny-spacing-left">Autogenerate</span>
          </Col>
          <Col md={6}>
            <input
              checked={!this.props.shouldAutogenerateBarcode}
              onChange={this.handleChangeShouldAutogenerateBarcode}
              type="radio"
              value={CUSTOM_BARCODE}
            />
            <span className="u-tiny-spacing-left">Custom</span>
          </Col>
        </Row>
        {!this.props.shouldAutogenerateBarcode && (
          <Row bufferRowReset={true}>
            <Col md={12}>
              <TextArea
                placeholder="Barcode"
                value={this.props.customBarcode}
                onChange={this.handleChangeCustomBarcode}
                className={classNames({'fieldInput-input--error': this.props.error != null})}
                rows={1}
              />
              {this.props.error ? <ErrorMessage error={this.props.error} /> : null}
            </Col>
          </Row>
        )}
      </FormGroup>
    );
  }
}

export default BarcodeInput;
